import React, { useEffect } from "react";
import MessageContainer from "@components/molecules/MessageContainer";
import { ButtonType } from "@components/atoms/Button/types";
import { useBootstrap } from "../../hooks/bootstrap/useBootstrap";
import {
  AppStateProps,
  InitialSetupScreenProps,
} from "@scenes/splash-screen/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useGetUser } from "@apis/user";
import useAxiosInterceptor from "@components/common/hooks/useAxiosInterceptor";
import { Platform } from "react-native";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useTranslation } from "react-i18next";

const InitialSetupScreen = ({
  appStateReady,
  setInitialScreen,
  setAppStateReady,
}: InitialSetupScreenProps) => {
  const userInfo = useUserInfo();
  const userId = userInfo.getUserId();
  const { settings } = useOrgSettingsSlice();
  const { t } = useTranslation();
  useAxiosInterceptor();
  const data = useGetUser(userId);
  const isWeb = process.env.EXPO_PUBLIC_PLATFORM === "web";

  useEffect(() => {
    const init = async () => {
      if (!userId) return;
      if (data.isSuccess) {
        await refetchData();
      }
    };

    if (isWeb && Platform.OS === "web") {
      if (typeof window !== "undefined" && window.DD_RUM?.setUser) {
        window.DD_RUM.onReady(function () {
          window.DD_RUM.setUser({
            id: `${userInfo?.user?.id}`,
            name: `${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`,
            email: `${userInfo?.user?.email}`,
            extraInfo: {
              country: `${userInfo?.user?.country}`,
              price_mode: `${userInfo?.user?.price_mode}`,
              user_company_id: `${userInfo?.user?.company_id}`,
              user_company_name: `${userInfo?.user?.company}`,
              user_organization_id: `${settings?.organization?.id?.toString()}`,
              user_organization_name: `${settings?.organization?.name?.toString()}`,
            },
          });
        });
      }
    }

    init();
  }, [data.isSuccess]);

  const { handleRetry, isRefetching, refetchData } = useBootstrap(
    appStateReady,
    setInitialScreen,
    setAppStateReady
  );

  if (appStateReady === AppStateProps.ERROR)
    return (
      <MessageContainer
        buttons={{
          type: ButtonType.primary,
          title: "Retry",
          onPressAction: handleRetry,
          loading: isRefetching,
          disabled: isRefetching,
        }}
        internetPreference={true}
        message={t(
          "global.text.somethingWentWrongDescription",
          "Oops, something went wrong. Please try again later."
        )}
      />
    );

  return null;
};

export default InitialSetupScreen;
